module.exports = __webpack_public_path__ + "static/media/woman-running.d1196949.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/woman-running.png
// module id = 134
// module chunks = 0